import { takeLatest, call, put, select } from "redux-saga/effects";
import {
  GET_AZURE_DASHBOARD_DETAILS,
  GET_AZURE_DASHBOARD_DETAILS_SUCCESS,
  GET_AZURE_DASHBOARD_DETAILS_ERROR,
  GET_FORECAST_BILL_AZURE,
  GET_FORECAST_BILL_AZURE_SUCCESS,
  GET_FORECAST_BILL_AZURE_ERROR,
  GET_DAILY_FORECAST_BILL_AZURE,
  GET_DAILY_FORECAST_BILL_AZURE_SUCCESS,
  GET_DAILY_FORECAST_BILL_AZURE_ERROR,
  GET_AZURE_DASHBOARD_SERVICES_DETAILS,
  GET_AZURE_DASHBOARD_SERVICES_DETAILS_SUCCESS,
  GET_AZURE_DASHBOARD_SERVICES_DETAILS_ERROR,
  GET_RESOURCE_GROUP_NAME,
  GET_RESOURCE_GROUP_NAME_SUCCESS,
  GET_RESOURCE_GROUP_NAME_ERROR,
} from "./constant";

import {
  getAzureDashboardDetailsApi,
  getAzureForecastBillApi,
  getAzureDailyForecastBillApi,
  getAzureDashboardServicesDetailsApi,
  getResourceGroupNamesApi,
} from "./api";

/**
 * action Type of GET_DASHBOARD_INFO
 * @param {Object} action
 */

function* getResourceGroupNameList(params) {
  try {
    const provider = yield select(state => state.CloudProviderStore ? state.CloudProviderStore.selectedProvider : "azure");
    const data = yield call(getResourceGroupNamesApi, params, provider);
    yield put({ type: GET_RESOURCE_GROUP_NAME_SUCCESS, data });
  } catch (error) {
    yield put({ type: GET_RESOURCE_GROUP_NAME_ERROR, error });
  }
}

function* getAzureForecastBillList(params) {
  try {
    const provider = yield select(state => state.CloudProviderStore ? state.CloudProviderStore.selectedProvider : "azure");
    const data = yield call(getAzureForecastBillApi, params, provider);
    yield put({ type: GET_FORECAST_BILL_AZURE_SUCCESS, data });
  } catch (error) {
    yield put({ type: GET_FORECAST_BILL_AZURE_ERROR, error });
  }
}

function* getAzureDailyForecastBillList(params) {
  try {
    const provider = yield select(state => state.CloudProviderStore ? state.CloudProviderStore.selectedProvider : "azure");
    const data = yield call(getAzureDailyForecastBillApi, params, provider);
    yield put({ type: GET_DAILY_FORECAST_BILL_AZURE_SUCCESS, data });
  } catch (error) {
    yield put({ type: GET_DAILY_FORECAST_BILL_AZURE_ERROR, error });
  }
}

function* getAzureDashboardDetailsList(params) {
  try {
    const provider = yield select(state => state.CloudProviderStore ? state.CloudProviderStore.selectedProvider : "azure");
    const data = yield call(getAzureDashboardDetailsApi, params, provider);

    yield put({ type: GET_AZURE_DASHBOARD_DETAILS_SUCCESS, data });
  } catch (error) {
    yield put({ type: GET_AZURE_DASHBOARD_DETAILS_ERROR, error });
  }
}

function* getAzureDashboardServicesDetailsList(params) {
  try {
    const provider = yield select(state => state.CloudProviderStore ? state.CloudProviderStore.selectedProvider : "azure");
    const data = yield call(getAzureDashboardServicesDetailsApi, params, provider);

    yield put({ type: GET_AZURE_DASHBOARD_SERVICES_DETAILS_SUCCESS, data });
  } catch (error) {
    yield put({ type: GET_AZURE_DASHBOARD_SERVICES_DETAILS_ERROR, error });
  }
}

/**
 * Get Login Saga
 */
export function* manageAzureDashboardDetailsSaga() {
  yield takeLatest(GET_RESOURCE_GROUP_NAME, getResourceGroupNameList);
  yield takeLatest(GET_AZURE_DASHBOARD_DETAILS, getAzureDashboardDetailsList);
  yield takeLatest(
    GET_AZURE_DASHBOARD_SERVICES_DETAILS,
    getAzureDashboardServicesDetailsList
  );
  yield takeLatest(GET_FORECAST_BILL_AZURE, getAzureForecastBillList);
  yield takeLatest(
    GET_DAILY_FORECAST_BILL_AZURE,
    getAzureDailyForecastBillList
  );
}
